import { useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'
import { useRequestHandler } from '@/hooks/useRequestHandler'

import { addPrescription, selectAddPrescriptionRequestTracker } from '@/redux/reducers/document.reducer'
import GeneratePrescriptionDialog from '../diagnostic/components/GeneratePrescriptionDialog'

export function PrescriptionPage() {
    const [searchParams] = useSearchParams()
    const { t } = useTranslation()
    const { enqueueSnackbar } = useSnackbar()

    const consultationId = searchParams.get('consultationId')
    const ordoclicPatientId = searchParams.get('ordoclicPatientId')
    const entityId = searchParams.get('entityId')

    const addPrescriptionRequestHandler = useRequestHandler({
        onSuccess: () => {
            enqueueSnackbar(t('notification.document.create.success'), { variant: 'success' })
        },
        onError: () => enqueueSnackbar(t('notification.document.create.error'), { variant: 'error' }),
        requestTrackerSelector: selectAddPrescriptionRequestTracker,
    })

    const handlePrescriptionCreated = (prescriptionId: string) => {
        if (consultationId) {
            addPrescriptionRequestHandler.dispatch(addPrescription({ consultationId, prescriptionId }))
        }
    }

    if (!consultationId || !ordoclicPatientId) return null

    return (
        <GeneratePrescriptionDialog
            open={true}
            onClose={() => window.close()}
            onPrescriptionCreated={handlePrescriptionCreated}
            ordoclicPatientId={ordoclicPatientId}
            entityId={entityId || undefined}
        />
    )
}

export default PrescriptionPage